import { atom } from "jotai"
import { emit } from "~src/utils/event"
import { AtomWelToken } from "./atom"

export const setAtomRid = atom(null, (_, set, str:string) => {
  emit("GetRidSuccessful")
  set(AtomWelToken, str)
})
